<template>
  <div class="full-width">
    <span>{{ getTitle(cell) }}</span>
    <div class="d-flex">
      <v-file-input
        v-if="mx_attachmentMode === attachmentModeOptions.cameraAndGallery"
        class="camera-and-gallery-only-file-input"
        style="margin-top: 10px"
        prepend-icon="mdi-camera"
        hide-input
        hide-details
        v-model="images"
        accept="image/*"
        @change="addImagePreview(cellKey)"
        multiple
        capture="user"
        :disabled="maxFilesReached"
        persistent-hint
        color="primary-action"
      />
      <!-- file input for CAMERA ONLY when there is no selection/ gallery input -->
      <v-file-input
        v-else-if="mx_attachmentMode === attachmentModeOptions.cameraOnly"
        class="camera-only-file-input"
        prepend-icon="mdi-camera"
        :label="$t('wb-config.fotoupload.media.foto_hinzufuegen')"
        v-model="images"
        accept="image/*"
        @change="addImagePreview(cellKey)"
        multiple
        capture="user"
        :hint="hint"
        :disabled="maxFilesReached"
        persistent-hint
        color="primary-action"
        outlined
        clearable
      />
      <!--    <v-file-input-->
      <!--      v-if="mx_attachmentMode === attachmentModeOptions.cameraAndGallery || mx_attachmentMode === attachmentModeOptions.cameraOnly"-->
      <!--      prepend-icon="mdi-camera"-->
      <!--      v-model="images"-->
      <!--      :label="$t('wb-config.fotoupload.media.foto_hinzufuegen')"-->
      <!--      :hint="maxFiles < 100 ? 'Maximal ' + maxFiles + ' Dateien' : ''"-->
      <!--      :disabled="maxFilesReached"-->
      <!--      persistent-hint-->
      <!--      multiple-->
      <!--      capture="user"-->
      <!--      accept="image/*"-->
      <!--      @change="addImagePreview(cellKey)"-->
      <!--      clearable-->
      <!--      outlined-->
      <!--      class="mt-2"-->
      <!--    />-->
      <v-file-input
        v-if="mx_attachmentMode === attachmentModeOptions.cameraAndGallery || mx_attachmentMode === attachmentModeOptions.galleryOnly"
        class="canera-and-gallery-or-gallery-only mt-2 flex-grow-1"
        :prepend-icon="mx_attachmentMode === attachmentModeOptions.galleryOnly ? 'mdi-paperclip' : 'mdi-image'"
        v-model="images"
        accept="image/*"
        @change="addImagePreview(cellKey)"
        :label="$t('wb-config.fotoupload.media.foto_hinzufuegen')"
        :hint="maxFiles < 100 ? 'Maximal ' + maxFiles + ' Dateien' : ''"
        :disabled="maxFilesReached"
        persistent-hint
        multiple
        clearable
        outlined
      />
    </div>
    <v-img v-for="(img, index) in input[cellKey]" :key="'img-' + index" :src="img" contain class="img-preview">
      <v-overlay absolute color="#9E9E9E" class="img-overlay">
        <v-icon class="preview-delete-icon" @click="removeImg(cellKey, index)"> mdi-close </v-icon>
      </v-overlay>
    </v-img>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import { preprocessImage } from '@/common/mediaUtils';
import { getTitle } from './wb-common';

export default {
  mixins: [common, configMixin],
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data() {
    return {
      galleryCameraSwitchEnabled: true, // for the time being this is a local flag, to enable the user to switch between camera and gallery. Might be configurable in future by tenant / usage
      images: [],
      getTitle,
    };
  },
  computed: {
    hint() {
      return this.maxFiles < 100 ? 'Maximal ' + this.maxFiles + ' Dateien' : '';
    },
    input: {
      get() {
        return this.$store.state[this.namespace].formInput;
      },
      set(val) {
        this.$store.state[this.namespace].formInput = val;
      },
    },
    cellKey() {
      return this.cell.key + this.mIndex;
    },
    maxFiles() {
      if (this.namespace === 'unfalldesk') {
        const moduleConfig = this.getModuleConfig('Unfalldesk', this.mx_instance);
        if (moduleConfig && moduleConfig.imageCount) {
          return moduleConfig.imageCount;
        }
      }
      if (this.namespace === 'wagenbuch') {
        const moduleConfig = this.getModuleConfig('Wagenbuch', this.mx_instance);
        if (moduleConfig && moduleConfig.imageCount) {
          return moduleConfig.imageCount;
        }
      }
      return 100;
    },
    maxFilesReached() {
      if (this.input[this.cellKey]) {
        if (Array.isArray(this.input[this.cellKey])) {
          return this.input[this.cellKey].length >= this.maxFiles;
        }
      }
      return false;
    },
  },
  methods: {
    async addImagePreview(key) {
      const existingImages = this.input[this.cellKey] ? this.input[this.cellKey].length : 0;
      const newImages = this.images.length;
      const addImages = this.maxFiles - existingImages;
      if (newImages > addImages) {
        this.images = this.images.slice(0, addImages);
      }
      this.images.forEach(async (image) => {
        const base64Image = await preprocessImage(image);
        if (this.input[key] === undefined) {
          this.$set(this.input, key, [base64Image]);
        } else {
          this.input[key].push(base64Image); //Reuse Base64 encoded image
        }
      });
      this.images = []; //Reset file-picker text
    },
    removeImg(key, index) {
      this.input[key].splice(index, 1);
    },
  },
};
</script>

<style scoped>
.img-preview {
  width: 200px;
  height: 150px;
  margin: 4px;
  display: inline-block;
}
.preview-delete-icon {
  font-size: 20px !important;
}
.preview-delete-icon:hover {
  cursor: pointer;
}
.img-overlay {
  left: auto;
  width: 20px;
  height: 20px;
}
.camera-and-gallery-only-file-input.v-input {
  flex: none !important;
}
</style>
